import { sendIframeError } from './events';
import { ErrorTypes, ErrorTypeMessage, ErrorTypeDetailItems } from './types';

export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_INTERNAL_SERVER_ERROR = 500;

export class WidgetError extends Error {
  constructor(type) {
    super(ErrorTypeMessage[type]);
    this.details = ErrorTypeDetailItems[type];
  }
}

export class InvalidAccessTokenError extends WidgetError {
  constructor() {
    super(ErrorTypes.invalidAccessToken);
    sendIframeError(ErrorTypes.invalidAccessToken);
  }
}

export class InvalidCompanyNumberError extends WidgetError {
  constructor() {
    super(ErrorTypes.invalidCompanyNumber);
    sendIframeError(ErrorTypes.invalidCompanyNumber);
  }
}

export class NoCreditScoreError extends WidgetError {
  constructor() {
    super(ErrorTypes.noCreditScore);
    sendIframeError(ErrorTypes.noCreditScore);
  }
}
